import type { AdditionalSelectors } from '@makemydeal/activities-credit-app';
import { DEFAULT_THEME } from '@makemydeal/dr-shared-components';

export const additionalSelectors: AdditionalSelectors = {
    getDealerId: (state) => {
        const dealerMMDId = state.dealer?.dealerMMDId;
        return Number(dealerMMDId);
    },
    getTheme: (state) => {
        const theme = state.dealer?.theme;
        return theme || DEFAULT_THEME;
    }
};
